// extracted by mini-css-extract-plugin
module.exports = {"content":"document_content__j5yNJ","accordionTitle":"document_accordionTitle__2Ot7t"};